<template>
<div class="position-relative mt-3" id="productTable">

  <div class="actions text-right" id="productTable-showAddEditDialog">
    <button class="btn btn-primary icon-button" @click="showAddEditDialog = true" id="productTable-add-Button">
      <span class="btn-icon" id="productTable-addButton-span"><i class="fa fa-plus" aria-hidden="true" id="productTable-addButton-data"></i></span>
      {{ 'ADD' | translate }}
    </button>
  </div>

  <vodal :show="showAddEditDialog"
         :width="400"
         :closeOnEsc="true"
         :closeOnClickMask="false"
         :customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}"
         animation="rotate"
         @hide="closeDialog">
    <product-add-edit-dialog :edited="editedRow"
                              :insurers="insurers"
                              :gimobjects="gimobjects"
                              :productlines="productlines"
                              :noClaimsDiscountTable="noClaimsDiscountTable"
                              @save="onSaveNew"
                              @update="onUpdate"
                              @close="closeDialog"
                              @updateInsurer="onInsurerChange"
                              @updateProductLine="onProductLineChange"
                              id="productTable-addEditDialog"
    ></product-add-edit-dialog>
  </vodal>
  <table class="table table-striped table-hover" id="productTable-tableData">
    <caption></caption>
    <tr>
      <th>Naam</th>
      <th>Omschrijving</th>
      <th>Maatschappij</th>
      <th>Branche</th>
      <th>productId</th>
      <th>ContextId</th>
      <th>functionId</th>
      <th>Enabled</th>
      <th></th>
    </tr>
    <template v-for="row in rows">
      <tr>
        <td>{{ row.name }}</td>
        <td>{{ row.description }}</td>
        <td>{{ row.insurerName }}</td>
        <td>{{ row.productLineName }}</td>
        <td>{{ row.productId }}</td>
        <td>{{ row.contextId }}</td>
        <td>{{ row.functionId }}</td>
        <td>{{ row.enabled }}</td>
        <td id="productTable-tableButtons">
          <button class="btn btn-success icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('EDIT')" @click="onEdit(row)" :id="'productTable-tableEditButton-'+row.name">
            <span class="btn-icon" :id="'productTable-tableEditSpan-'+row.name"><i class="fa fa-pencil" aria-hidden="true" :id="'productTable-tableEditData-'+row.name"></i></span>
          </button>
          <button class="btn btn-danger icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('DELETE')" @click="confirmDelete(row)" :id="'productTable-tableDeleteButton-'+row.name">
            <span class="btn-icon" :id="'productTable-tableDeleteSpan-'+row.name"><i class="fa fa-trash-o" aria-hidden="true" :id="'productTable-tableDeleteData-'+row.name"></i></span>
          </button>
        </td>
      </tr>
    </template>
  </table>
  <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
              @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.id)">
            </confirm-dialog>
</div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import ProductAddEditDialog from './ProductAddEditDialog';
import Datepicker from 'vuejs-datepicker';
import Vodal from 'vodal';
import ConfirmDialog from '../../dialog/ConfirmDialog.vue';

export default {
  components: { ProductAddEditDialog, Datepicker, Vodal, ConfirmDialog },
  data() {
    return {
      rest: this.initRestService(),
      filter: '',
      rows: [],
      newRows: [],
      editedRow: null,
      productlines: [],
      noClaimsDiscountTable: [],
      insurers: [],
      gimobjects: [],
      showAddEditDialog: false,
      showDeleteConfirmDialog: false,
      selectedInsurer: '',
      selectedProductLine: ''
    }
  },
  beforeMount() {
    this.loadRows();
    this.loadInsurers();
    this.loadProductlines();
    this.loadNoClaimsDiscountTable();
    this.loadGimobjects(this.selectedProductLine, this.selectedInsurer);
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadRows() {
      const productResponse = await this.rest.getAllProductRows();
      this.rows = productResponse.data;
    },
    async loadProductlines() {
      const productlinesResponse = await this.rest.getAllProductlineRows();
      this.productlines = productlinesResponse.data;
    },
    async loadNoClaimsDiscountTable() {
      const noClaimsDiscountTableResponse = await this.rest.getAllNoclaimsdiscountRows();
      this.noClaimsDiscountTable = noClaimsDiscountTableResponse.data;
    },
    async loadInsurers() {
      const insurerNamesResponse = await this.rest.getAllInsurerNames();
      this.insurers = insurerNamesResponse.data;
    },
    async loadGimobjects(productLine, insurer) {
      if ((productLine && insurer)) {
        const gimobjectsResponse = await this.rest.getGimobjectsByProductLineAndInsurer(productLine, insurer);
        this.gimobjects = gimobjectsResponse.data;
      }
    },
    async onSaveNew(row) {
      await this.rest.createProductRow(row);
      this.closeDialog();
      this.loadRows();
    },
    async onUpdate(row) {
      await this.rest.updateProductRow(row);
      this.closeDialog();
      this.loadRows();
    },
    onEdit(row) {
      this.editedRow = { ...row };
      this.showAddEditDialog = true;
      this.loadGimobjects(row.productLineName, row.insurerName);
    },
    onRemove(rowId) {
      this.rows = this.rows.filter(row => row.id !== rowId);
      this.rest.deleteProductRow(rowId);
      this.showDeleteConfirmDialog = false;
    },
    confirmDelete(row) {
      this.selectedRow = row;
      this.showDeleteConfirmDialog = true;
    },
    closeDialog() {
      this.showAddEditDialog = false;
      this.editedRow = false;
    },
    async onInsurerChange(insurerName) {
      this.selectedInsurer = insurerName;
      await this.loadGimobjects(this.selectedProductLine, this.selectedInsurer);
    },
    async onProductLineChange(productLineName) {
      this.selectedProductLine = productLineName;
      await this.loadGimobjects(this.selectedProductLine, this.selectedInsurer);
    }
  }
}
</script>

<style lang="scss" scoped>
  >>> .vue-table {
    border: 0;

    th, td {
      border-right: 0;
      border-bottom: 0;
      border-left: 0;
    }

    thead > tr > th {
      padding-right: .75rem;
      padding-left: 30px !important;
    }

    .arrow:before {
      bottom: 12px;
      right: auto;
      left: 12px;
      font-family: 'FontAwesome';
    }

    .icon-button {
      opacity: 0;
      transition: opacity .1s ease-out;
    }

    tr:hover .icon-button {
      opacity: 1;
    }
  }

  .actions {
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 0;

    .icon-button {
      padding-right: 15px;
      padding-left: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/product/ProductTable.vue